// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "description": {
            "displayName": "{{i18n.descriptionLabel}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": "",
            "numberOfLines": 3
        }
    },
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.libraryid",
                "props.parentfolder"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "parentfolder": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "actions": {
        "createLibraryFolder": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "accSessionId": "{{props.accsessionid}}",
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "mutation CreateLibraryFolder( $libraryId: String, $parentFolder: String, $createLibraryFolderInput: CreateLibraryFolderInput) {createLibraryFolder( libraryId: $libraryId, parentFolder: $parentFolder, createLibraryFolderInput: $createLibraryFolderInput )}",
                        "variables": {
                            "libraryId": "{{props.libraryid}}",
                            "parentFolder": "{{props.parentfolder}}",
                            "createLibraryFolderInput": {
                                "name": "{{data.name.dbValue}}",
                                "description": "{{data.description.dbValue}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraryFolderCreated": "data.data.createLibraryFolder",
                "error": "data.data.CreateLibraryFolder"
            },
            "events": {
                "failure": [
                    {
                        "name": "createLibraryFolderFailure",
                        "eventData": {
                            "eventData": "{{libraryFolderCreated}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "createLibraryFolderSuccess",
                        "eventData": {
                            "eventData": "{{libraryFolderCreated}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        }
    },
    "conditions": {
        "enableAddButton": {
            "expression": "data.name.dbValue"
        }
    },
    "onEvent": [
        {
            "eventId": "updateLibrarySuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "updateLibrarySuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "updateLibraryFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "updateLibraryFailure",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "createLibraryFolderSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "createLibraryFolderSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "i18n": {
        "name": [
            "libraryMessages"
        ],
        "descriptionLabel": [
            "libraryMessages"
        ],
        "addButton": [
            "libraryMessages"
        ],
        "nameError": [
            "libraryMessages"
        ]
    },
    "_viewModelId": "DesCreateLibraryFolder",
    "_uniqueViewModelId": "DesCreateLibraryFolder",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-textbox prop="data.name"></aw-textbox>
        <aw-textarea prop="data.description"></aw-textarea>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button class='small' button-type='accent-high-contrast' size='stretched' action='createLibraryFolder' enable-when="conditions.enableAddButton">{{i18n.addButton}}</aw-button>
    </aw-panel-footer>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwTextbox {...getField("data.name", fields, $index, null, null )}>
            </AwTextbox>
            <AwTextarea {...getField("data.description", fields, $index, null, null )}>
            </AwTextarea>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen className="small" buttonType="accent-high-contrast" size="stretched" action={actions.createLibraryFolder} enableWhen={AwParseService.instance( "conditions.enableAddButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.addButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;